import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>The Primacy-Recency effect is also the reason why first
                                                impressions tend to stick. Make sure you make a good one,
                                                because it may be difficult to alter it at a later stage. Now,
                                                this shouldn’t send you into a spin about whether people
                                                instantly like or dislike you – just remember that you’ll always
                                                give a better impression by never pretending to be anything
                                                other than yourself! Relax, and you’ll find whoever you’re
                                                talking to will, too.</p>
                                            <div className="browncontentbg uiheading keyquestionpad">
                                                <p>Don’t make too many points. Research shows that our ability
                                                    to retain information (memory) at any given time is limited.
                                                    If too much is offered it either prevents us absorbing more
                                                    or ‘overwrites’ what we’re currently remembering! Stick to
                                                    the most important points of your message rather than
                                                    bombarding your audience with information and causing
                                                    cerebral gridlock!</p>
                                            </div>
                                            <br/>
                                                <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                    <span
                                                        className="heading">THE EFFECTS OF COMMON PITFALLS</span>
                                                </div>

                                                <p>Here are things to watch out for and try to avoid:</p>

                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink">
                                                    <tbody>
                                                    <tr>
                                                        <th width="100%" align="left" valign="top" colSpan="2"
                                                            className="green_curve green_curve1">Common Pitfalls
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th width="20%" align="left" valign="top"
                                                            style={{borderTopLeftRadius: 0}}>Action
                                                        </th>
                                                        <th width="60%" align="left" valign="top"
                                                            style={{borderTopRightRadius: 0}}>Effect
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p
                                                            className="object ilead-conten">Objective/message is
                                                            not clear</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="lightgreen"><p
                                                            className="object ilead-conten">People don’t ‘get
                                                            it’, lose interest and become confused and
                                                            bored.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="object ilead-conten">Not adapted to
                                                            audience/
                                                            not relevant</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="darkgreen" style={{paddingTop:'24px'}}><p
                                                            className="ilead-conten"
                                                            style={{marginTop: '-4px'}}>The message doesn’t relate
                                                            to the audience and they may
                                                            therefore feel frustrated, bored and disengaged.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen" style={{paddingTop:'24px'}}><p
                                                            className="ilead-conten"
                                                            style={{marginTop: '-3px'}}>Lack of rapport</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="lightgreen"><p
                                                            className="ilead-conten">There is less willingness
                                                            to warm to you and build trust, as well as less
                                                            belief in the message. The audience may
                                                            disengage.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="ilead-conten">Lack of credibility</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="ilead-conten"> The audience won’t trust
                                                            you or, therefore, buy in to your
                                                            message, however persuasive you are.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen" style={{paddingTop:'24px'}}><p
                                                            className="ilead-conten"
                                                            style={{marginTop: '-3px'}}>Lack of confidence</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="lightgreen"><p
                                                            className="ilead-conten">Your lack of confidence can
                                                            transmit to the audience and reduce their confidence
                                                            in your message and likelihood of accepting what
                                                            you’re saying.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="ilead-conten">Incorrect tone or body
                                                            language</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="ilead-conten">Your message is diluted
                                                            because your verbal and non-verbal
                                                            cues are confusing or contradict the message.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p
                                                            className="ilead-conten">Not memorable</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="lightgreen"><p
                                                            className="ilead-conten">Only parts of the message
                                                            are remembered and they may not
                                                            be the most important.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen" style={{paddingTop:'24px'}}><p
                                                            className="ilead-conten"
                                                            style={{marginTop: '-3px'}}>Making too many
                                                            points</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="ilead-conten">The audience may find it
                                                            hard to remember everything, lose focus on the key
                                                            points and may become bored or confused.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen" style={{paddingTop:'24px'}}><p
                                                            className="ilead-conten"
                                                            style={{marginTop: '-3px'}}>Repetition/fillers</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="lightgreen"><p
                                                            className="ilead-conten">The audience can become
                                                            frustrated with hearing the same
                                                            points over and over and your message becomes
                                                            diluted.
                                                            The audience may also stop listening.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="ilead-conten">Transactional analysis
                                                            – use of Parent or
                                                            Child approach</p>
                                                        </td>
                                                        <td width="60%" align="left" valign="top"
                                                            className="darkgreen"><p
                                                            className="ilead-conten">You may come across as
                                                            either patronising (parent) or without
                                                            enough gravitas to be taken seriously (child).
                                                            Either way will
                                                            result in the audience not taking your messages on
                                                            board.</p>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>


                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page3')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div onClick={this.props.handleChangePage('Page5')}
                                                         className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }